export const THUMBNAIL_BORDER_RADIUS = '8px';
